import React from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { MONTH_DAY_COUNT, WEEK_DAY_COUNT } from '../constants';
import { DaySkeleton, Header, WeekSkeletonContainer, WeeksSkeleton } from '../styled';

const CalendarLoading = () => {
	return (
		<>
			<Header>
				{Array.from({ length: WEEK_DAY_COUNT }).map((_, index) => (
					<DaySkeleton key={index}>
						<Skeleton height={1} width={3} />
					</DaySkeleton>
				))}
			</Header>
			<WeekSkeletonContainer>
				{Array.from({ length: MONTH_DAY_COUNT })
					.fill(null)
					.map((_, index) => (
						<WeeksSkeleton key={index}>
							<Skeleton height={1} width={1.5} />
							<Skeleton height={3} width={3} />
						</WeeksSkeleton>
					))}
			</WeekSkeletonContainer>
		</>
	);
};

export { CalendarLoading };
